export default __webpack_public_path__ + "static/android-09522ec15fe49480ad9a029bdb07369f.png";